module.exports = __webpack_public_path__ + "media/images/logo-small-1121330b.svg";